import { render } from "./SegmentationSimpleProperty.vue?vue&type=template&id=2dbef6d9&scoped=true"
import script from "./SegmentationSimpleProperty.vue?vue&type=script&lang=ts"
export * from "./SegmentationSimpleProperty.vue?vue&type=script&lang=ts"

import "./SegmentationSimpleProperty.vue?vue&type=style&index=0&id=2dbef6d9&lang=scss&scoped=true"
import "./SegmentationSimpleProperty.vue?vue&type=style&index=1&id=2dbef6d9&lang=scss"
script.render = render
script.__scopeId = "data-v-2dbef6d9"

export default script